import { render, staticRenderFns } from "./ReviewYourAnswersPage.vue?vue&type=template&id=438bc61c"
import script from "./ReviewYourAnswersPage.vue?vue&type=script&lang=ts"
export * from "./ReviewYourAnswersPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports